import { createStore } from "redux";

const initialState = {
  showFilterDiv: false,
  filter: [],
  selectedFilters: {},
  selectedMenu: "",
  downloadOptions: {},
  creUser: "",
};

const reducer = (state = initialState, action) => {
  if (action.type === "HIDE_FILTER_DIV") {
    return Object.assign({}, state, {
      showFilterDiv: action.payload.showFilterDiv,
    });
  }

  if (action.type === "SHOW_FILTER_DIV") {
    return Object.assign({}, state, {
      showFilterDiv: action.payload.showFilterDiv,
    });
  }

  if (action.type === "CHANGE_SELECTED_FILTER") {
    return Object.assign({}, state, {
      selectedFilters: action.payload,
    });
  }
  if (action.type === "CHANGE_SELECTED_FILTER_MENU") {
    return Object.assign({}, state, {
      selectedFilters: action.payload,
      selectedMenu: action.selectMenu,
    });
  }
  if (action.type === "CHANGE_SELECTED_SIDE_MENU") {
    return Object.assign({}, state, {
      selectedMenu: action.selectMenuNew,
    });
  }
  if (action.type === "SET_DOWNLOAD_PERMISSIONS") {
    return Object.assign({}, state, {
      downloadOptions: action.payload,
    });
  }
  if (action.type === "CHECK_USER_COMPANY") {
    return Object.assign({}, state, {
      creUser: action.payload,
    });
  }
  if (action.type === "ADD_TO_FILTER") {
    // return Object.assign({}, state, {
    //   filter[action.payload.key]: action.payload.value
    // })

    // let v = state.filter[action.payload.key] = action.payload.value;
    // console.log(state.filter, 'f', action.payload.key);
    // if(action.payload.key in state.filter){
    //   console.log('exists');
    state.filter[action.payload.key] = action.payload.value;
    // }

    return {
      ...state,
      filter: state.filter,
    };
    // console.log(state.filter);
    // return {
    //   ...state, filter:[...state.filter[action.payload.key] = action.payload.value]
    // }
  }
  //{[action.payload.key] : action.payload.value}

  if (action.type === "REMOVE_FROM_FILTER") {
    state.filter[action.payload.key] = action.payload.value;
    return {
      ...state,
      filter: state.filter,
    };
    // console.log(state.filter[action.payload.key]);
    // console.log(action.payload.value)
    // return Object.assign({}, state, {
    //     showFilterDiv: action.payload.showFilterDiv
    // })
  }

  return state;
};

const store = createStore(reducer);

export default store;
